// src/components/EventCalendar.js
import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import Modal from 'react-modal';
import { fetchEvents } from '../services/airtable';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './EventCalendar.css'; // Import custom CSS file
import CustomToolbar from './CustomToolbar'; // Import custom toolbar

const localizer = momentLocalizer(moment);

const EventCalendar = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const loadEvents = async () => {
    const events = await fetchEvents();
    setEvents(events);
  };

  useEffect(() => {
    loadEvents();

    const interval = setInterval(() => {
      loadEvents();
    }, 3600000); // 1 hour in milliseconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const eventPropGetter = (event) => {
    const backgroundColor = '#C11F32';
    const style = {
      backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block',
      padding: '10px',
      margin: '5px 0',
    };
    return {
      style,
    };
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedEvent(null);
  };

  if (events.length === 0) {
    return <div>No events found.</div>;
  }

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 800 }} // Increased height
        eventPropGetter={eventPropGetter}
        onSelectEvent={handleEventClick}
        views={['month']} // Only enable month view
        defaultView="month"
        toolbar={true} // Ensure toolbar is enabled
        components={{
          toolbar: CustomToolbar,
        }}
        onNavigate={(date, view) => loadEvents(date, view)} // Load events when navigating
      />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Event Details"
        className="EventModal"
        overlayClassName="EventModalOverlay"
      >
        {selectedEvent && (
          <div className="modal-content">
            <h2>{selectedEvent.title}</h2>
            <p><strong>Start:</strong> {selectedEvent.start.toLocaleString()}</p>
            <p><strong>End:</strong> {selectedEvent.end.toLocaleString()}</p>
            <p><strong>Location:</strong> {selectedEvent.location}</p>
            <p><strong>Description:</strong> {selectedEvent.description}</p>
            <button onClick={closeModal} className="modal-close-button">Close</button>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default EventCalendar;
